export default "__VITE_ASSET__ab7c87ae__"